import {
  FETCH_FUNCTION_BY_ID_REQUEST,
  FETCH_FUNCTION_BY_ID_SUCCESS,
  FETCH_FUNCTION_BY_ID_ERROR,
} from "../../actions";

import { FunctionSTORE } from "../types";
import { FunctionsActions } from "../../actionCreators";

const initialState: FunctionSTORE = {
  isFetching: false,
};

const idReducer = (
  state = initialState,
  action: FunctionsActions
): FunctionSTORE => {
  switch (action.type) {
    case FETCH_FUNCTION_BY_ID_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_FUNCTION_BY_ID_SUCCESS:
      return {
        ...state,
        ...action.payload.function,
        isFetching: false,
      };

    case FETCH_FUNCTION_BY_ID_ERROR:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default idReducer;
